import React, {useState, useContext} from 'react';
import AddNoteView from './AddNoteView';
import Spinner from '../../../Spinner/Spinner';
import swal from 'sweetalert';
import {useLocation} from 'react-router-dom';
import {useNavigate} from 'react-router';
import {MadricContext} from '../../../../Context/MadricContext';
import {addNote} from '../../../../services/MadricService';

/**
 * Permet l'ajout des médias
 * @param {*} props props
 * @return {JSX}
 */
function AddNote(props) {
  const [isLoading, setIsLoading] = useState(false);

  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    let month = today.getMonth() + 1;
    let day = today.getDate();

    month = month < 10 ? `0${month}` : month;
    day = day < 10 ? `0${day}` : day;

    return `${year}-${month}-${day}`;
  };

  const [form, setForm] = useState({
    note: '',
    selectedDate: getCurrentDate(),
    extra1: false,
    extra2: false,
    extra3: false,
  });

  const [errors, setErrors] = useState({});
  const location = useLocation();
  const navigate = useNavigate();
  const {setWhatToShow, setProjectInfo} = useContext(MadricContext);


  const openModal = () => {
    swal('Votre note a été enregistré');
  };

  const handleChangeValue = (event) => {
    setForm({
      ...form,
      [event.target.name]: event.target.value,
    });
  };

  const handleChangeCheckbox = (event) => {
    setForm({
      ...form,
      [event.target.name]: event.target.checked,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();


    const errorsForm = {};
    setErrors(errorsForm);

    if (form.note === null || form.note === '') {
      errorsForm.note = 'La note est obligatoire';
    }


    if (Object.keys(errorsForm).length > 0) {
      setErrors(errorsForm);
    } else {
      setIsLoading(true);


      await addNote(form, location.state.id).then((r) => {
        setProjectInfo((previous) => [r.data.data, ...previous].sort((a, b) => {
          if (a.date < b.date) {
            return 1;
          }
          return -1;
        }));
        openModal();
      }).finally(() => {
        setWhatToShow('6');
        navigate('/chantier/' + location.state.id);
        setIsLoading(false);
      });
    }
  };

  return (
    <React.Fragment>
      {isLoading && <Spinner />}
      <AddNoteView
        handleSubmit={handleSubmit}
        checkedChantier={props.checkedChantier}
        handleChangeValue={handleChangeValue}
        handleChangeCheckbox={handleChangeCheckbox}
        form={form}
        setForm={setForm}
        errors={errors}
      />
    </React.Fragment>
  );
}

export default AddNote;
